// @ts-nocheck
import React from 'react';
import { sx } from '../sx';
import InfoTip from './InfoTip';

export default function CohortSwitch({ label, on, disabled, tip, onToggle, testId }: { label: string; on: boolean; disabled?: boolean; tip?: string; onToggle?: () => void; testId?: string }) {
  return (
    <span style={sx(`flex:none;display:inline-flex;align-items:center;gap:6px`)}>
      <button
        type="button"
        role="switch"
        aria-checked={!!on}
        aria-label={label}
        data-testid={testId}
        disabled={!!disabled}
        onClick={disabled ? undefined : onToggle}
        style={sx(`flex:none;display:inline-flex;align-items:center;gap:7px;height:28px;padding:0;border:none;background:none;font-family:inherit;font-size:12px;color:${disabled ? 'var(--ink-4)' : 'var(--ink-2)'};cursor:${disabled ? 'default' : 'pointer'}`)}
      >
        <span aria-hidden="true" style={sx(`position:relative;flex:none;width:30px;height:17px;border-radius:999px;background:${on && !disabled ? '#0052CD' : '#C9D0DD'};opacity:${disabled ? 0.6 : 1};transition:background .15s`)}>
          <span style={sx(`position:absolute;top:2px;left:${on ? 15 : 2}px;width:13px;height:13px;border-radius:999px;background:#fff;box-shadow:0 1px 2px rgba(8,35,76,0.25);transition:left .15s`)}></span>
        </span>
        {label}
      </button>
      <InfoTip text={tip} label={label} />
    </span>
  );
}
